var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('AccountAdminMenu',[_c('div',[_c('h1',[_vm._v("Account settings")]),_c('h3',[_vm._v(" Change your password ")]),_c('ChangePassword')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }